export const DISPLAY_TEXT = {
  ADD_GROUP: $localize`Add Group`,
  GROUP_CODE: $localize`Group Code`,
  GROUP_CODE_PLACEHOLDER: $localize`Enter Group Code`,
  DESCRIPTION: $localize`Description`,
  DESCRIPTION_PLACEHOLDER: $localize`Enter Description`,
  ADD: $localize`Add`,
  RESET: $localize`Reset`,
};
